var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.372 8.804a.739.739 0 0 0-1.038-1.05l-2.502 2.47a.739.739 0 0 0 1.038 1.05l2.502-2.47ZM7.506 20.005c0 .408-.33.738-.739.738H3.24a.739.739 0 1 1 0-1.477h3.528c.408 0 .739.33.739.739ZM37.5 20.005c0 .408-.33.738-.739.738h-3.528a.738.738 0 1 1 0-1.477h3.528c.408 0 .739.33.739.739ZM11.174 28.742a.739.739 0 0 1-.005 1.045l-2.495 2.47a.739.739 0 1 1-1.04-1.05l2.495-2.47a.739.739 0 0 1 1.045.006ZM32.383 32.252a.738.738 0 0 1-1.044.005l-2.495-2.47a.739.739 0 1 1 1.04-1.05l2.494 2.47c.29.287.292.755.005 1.045ZM11.175 11.268a.739.739 0 0 1-1.045.006l-2.502-2.47a.739.739 0 1 1 1.038-1.05l2.502 2.47c.29.286.293.753.007 1.044Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.17 10.6a9.486 9.486 0 0 0-4.848 18.136v2.616a2.282 2.282 0 0 0 2.196 2.366h2.958a2.282 2.282 0 0 0 2.203-2.367v-2.606a9.478 9.478 0 0 0 5.881-8.738v-.004a9.486 9.486 0 0 0-8.39-9.403Zm6.913 9.404a8 8 0 0 1-5.27 7.493h-5.618a8.01 8.01 0 1 1 10.888-7.493Zm-5.88 11.363v.034a.805.805 0 0 1-.748.84h-2.909a.805.805 0 0 1-.748-.84V28.974h4.404v2.393Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.408cf9bef982f458ee5b8dd8c039e7d4.svg";
export { ForwardRef as ReactComponent };